/* eslint-disable no-multi-assign, no-plusplus */

/**
 * Polyfills for prepend, append, before, after not implemented in IE/Edge
 *
 * - https://developer.mozilla.org/en-US/docs/Web/API/ParentNode/prepend
 * - https://developer.mozilla.org/en-US/docs/Web/API/ParentNode/append
 * - https://developer.mozilla.org/en-US/docs/Web/API/ChildNode/before
 * - https://developer.mozilla.org/en-US/docs/Web/API/ChildNode/after
 */

const { Document, DocumentFragment } = global;

if (Element.prototype.prepend === undefined) {
  Element.prototype.prepend =
    Document.prototype.prepend =
    DocumentFragment.prototype.prepend =
      function prepend(...args) {
        for (let i = args.length; i; i--) {
          if (args[i - 1] instanceof Node)
            this.insertAdjacentElement("afterbegin", args[i - 1]);
          else this.insertAdjacentText("afterbegin", args[i - 1]);
        }
      };

  Element.prototype.append =
    Document.prototype.append =
    DocumentFragment.prototype.append =
      function append(...args) {
        for (let i = 0; i < args.length; i++) {
          if (args[i] instanceof Node)
            this.insertAdjacentElement("beforeend", args[i]);
          else this.insertAdjacentText("beforeend", args[i]);
        }
      };

  Element.prototype.before =
    Document.prototype.before =
    DocumentFragment.prototype.before =
      function before(...args) {
        for (let i = 0; i < args.length; i++) {
          if (args[i] instanceof Node)
            this.insertAdjacentElement("beforebegin", args[i]);
          else this.insertAdjacentText("beforebegin", args[i]);
        }
      };

  Element.prototype.after =
    Document.prototype.after =
    DocumentFragment.prototype.after =
      function after(...args) {
        for (let i = args.length; i; i--) {
          if (args[i - 1] instanceof Node)
            this.insertAdjacentElement("afterend", args[i - 1]);
          else this.insertAdjacentText("afterend", args[i - 1]);
        }
      };
}

export default null;
